"use client";
import { jsxs as u, jsx as e } from "react/jsx-runtime";
import { cva as f } from "class-variance-authority";
import { SelectRoot as m, SelectTrigger as b, SelectValue as k, SelectIcon as p } from "../../atoms/Select/Select.mjs";
import { cn as l } from "../../../utils/utils.mjs";
const x = f(
  "flex items-center border font-semibold text-base [&_[data-slot=select-value]_span]:font-semibold dark:bg-neutral-dark-100 dark:text-neutral-dark-1000 dark:border-transparent dark:hover:not-disabled:border-neutral-dark-600 dark:disabled:bg-neutral-dark-900 dark:disabled:border-neutral-dark-500 dark:disabled:text-neutral-dark-600",
  {
    variants: {
      variant: {
        default: "h-14 min-w-32 w-fit rounded-full p-4 gap-4",
        "icon-only": "h-10 w-11 rounded-3xl px-2 py-4 gap-1"
      }
    },
    defaultVariants: {
      variant: "default"
    }
  }
), w = ({
  className: i,
  children: n,
  variant: r = "default",
  icon: t,
  placeholder: d,
  selectTriggerProps: o,
  selectValueProps: s,
  ...c
}) => {
  const a = r === "icon-only";
  return /* @__PURE__ */ u(m, { ...c, children: [
    /* @__PURE__ */ e(
      b,
      {
        "aria-label": a ? d : void 0,
        iconPrefix: t ? /* @__PURE__ */ e("span", { className: "[&_path]:fill-white", children: t }) : void 0,
        iconSuffix: /* @__PURE__ */ e(p, { className: l(a ? "size-2" : "size-4") }),
        className: l(x({ variant: r }), i),
        ...o,
        children: !a && /* @__PURE__ */ e(k, { placeholder: d, ...s })
      }
    ),
    n
  ] });
};
export {
  w as MediaSelect
};
